import { Controller } from "@hotwired/stimulus"
import { trackDiagnostic } from "../utils/diagnostic-event.util"

// Declarative reporting of a dead end the server just rendered.
//
// Server-rendered error states are the case the util exists for, and they are
// spread across every provider template in the import wizard. Rather than a
// tracking call in each of them, the controller that decided "this is an error"
// renders one hidden element carrying this controller — see
// Settings::ImportsController#respond and shared/_diagnostic_event.
//
// Fires on connect, which is what makes it work under Turbo: the element arrives
// in a Turbo Stream, Stimulus connects it, the event goes out. No load hook would
// see it.
export default class extends Controller {
  static values = {
    name: String,
    // A Hash rendered to JSON by the partial. Object, not separate values, so a
    // call site can carry whatever its own closed vocabulary needs.
    data: Object
  }

  connect() {
    trackDiagnostic(this.nameValue, this.hasDataValue ? this.dataValue : {})
  }
}
